

function sendAnalytics(metricType, metricObj) {
  if (typeof metricType === 'undefined') {
    return;
  }

  window.mready = window.mready || [];
  window.mready.push(function(metrics) {
    metrics[metricType](metricObj);
  });

}

const defaults = {
  metric: 'ev',
  events: [ 'event9' ],
};

export const sendEventWithPageLoad = (value) => {
  if (!value) return console.log('no value to send with page load');
  window.mconfig = window.mconfig || {};
  window.mconfig.events = window.mconfig.events || [];
  window.mconfig.events.push(defaults.events);
  console.log('to send with PI', defaults.events, value);
  window.mconfig.eVar25 = value;
};

const eventTracking = (data, contextData = {}) => {
  const {
    metric = defaults.metric,
    events = defaults.events,
    ...trackingData
  } = data || {};

  // if metro app env data exists, then set evar3 so we can segment the h3o events
  if (contextData.isApp) {
    console.log('contextData.isApp - set new evar3 value and net_platform');
    trackingData.eVar3 = `${ contextData.site } h3o app ${ contextData.platform }`;
    trackingData.net_platform = 'app';
  }

  if (contextData.isAmp) {
    console.log('contextData.isAmp - set new evar3 value and net_platform');
    trackingData.eVar3 = `${ contextData.site } amp`;
    trackingData.net_platform = 'amp';
  }

  console.log(metric, events, trackingData, contextData);

  if (trackingData && !contextData.isPreview) {
    sendAnalytics(metric, {
      events,
      ...trackingData
    });
  } else {
    console.log('no tracking data provided');
  }
};

export default eventTracking;
